/* eslint-disable no-underscore-dangle */

import { DEFAULTS, DEVICE_PLATFORM_MAP } from '../../../const';

const getSdkConfig = config => {
  const {
    gdpr,
    showUserFeedback,
    userFeedbackQuestionNegative,
    userFeedbackQuestionPositive,
    userFeedbackTagsNegative,
    userFeedbackTagsPositive,
  } = config;

  return {
    gdpr,
    showUserFeedback,
    userFeedbackQuestionNegative,
    userFeedbackQuestionPositive,
    userFeedbackTagsNegative,
    userFeedbackTagsPositive,
  };
};

const _normalizePartnerData = (partnerData, meta) => {
  const returnData = {};
  const activeList = [];

  const data = partnerData || {};
  meta.gs.activePartners.forEach(partnerName => {
    if (!data[partnerName]) data[partnerName] = DEFAULTS.PARTNER_SETTINGS;
  });

  Object.keys(data).forEach(key => {
    if (!meta.gs.activePartners.includes(key)) return;

    const {
      botBreakMessage,
      outlierMessage,
      taskboxSettings,
      sdkConfiguration,
    } = data[key];

    const {
      showHaptikBranding,
      businessIcon,
      webhookEnabled,
      businessActive,
      ...config
    } = sdkConfiguration;

    const sdkConfig = config;
    const androidConfig = getSdkConfig(config);
    const iosConfig = getSdkConfig(config);

    const taskIds = meta.pss.allTasks.map(task => task.id);
    const tasks = {};
    Object.keys(taskboxSettings.tasks).forEach(taskId => {
      if (taskIds.includes(taskId)) {
        tasks[taskId] = taskboxSettings.tasks[taskId];
      }
    });

    if (businessActive) {
      activeList.push(+meta.reversePartnerIdMap[key]);
    }

    returnData[`${meta.reversePartnerIdMap[key]}`] = {
      branding_url: '',
      tasks: taskboxSettings.tasks,
      botbreak_template: botBreakMessage,
      outlier_template: outlierMessage,
      active: businessActive,
      hide_branding: !showHaptikBranding,
      image_url: businessIcon,
      webhook_enabled: !!webhookEnabled,
      config: {
        [DEVICE_PLATFORM_MAP.WEBSDK]: sdkConfig,
        [DEVICE_PLATFORM_MAP.ANDROIDSDK]: androidConfig,
        [DEVICE_PLATFORM_MAP.IOSSDK]: iosConfig,
      },
    };
  });

  return { partnerData: returnData, activeList };
};

const _reverseIndex = index => {
  return Object.keys(index).reduce(
    (reversedIndex, key) => Object.assign(reversedIndex, { [index[key]]: key }),
    {}
  );
};

const normalizeToBusinessAPI = (data, meta) => {
  const {
    generalSettings: gs,
    partnerSpecificSettings: pss,
    botPromptTriggerSettings: bps,
  } = data;
  const reversePartnerIdMap = _reverseIndex(meta.partnerIdMap);
  const { partnerData, activeList } = _normalizePartnerData(
    pss.settingsIndexed,
    {
      reversePartnerIdMap,
      gs,
      pss,
    }
  );

  return {
    id: gs.id,
    name: gs.businessName,
    via_name: gs.businessViaName,
    order: gs.order,
    preview_text: gs.previewText,
    default_domain: gs.defaultBot,
    fallback_domain: gs.fallbackBot,
    feedback_delay: gs.collectFeedbackDelay,
    to_assistant: gs.enableHumanAssistance,
    requests_pii: gs.requestsPii,
    chat_tool: gs.liveAgentChatTool,
    run_smalltalk: gs.enableSmallTalk,
    multiple_feedbacks: gs.collectFeedbackMultiple,
    domain_list: gs.activeBots,
    partner_list: gs.activePartners.map(
      partner => +reversePartnerIdMap[partner]
    ),
    partners: gs.activePartners.map(partner => +reversePartnerIdMap[partner]),
    task_box_header: pss.taskboxMessage || 'Hi There!',
    tasks: pss.allTasks.map((task, i) => ({
      ...task,
      relevance: i,
    })),
    partner_data: partnerData,
    trigger_id_list: bps.map(trigger => trigger.id).filter(id => !!id),
    language_code: gs.languageCode,
    online: gs.online,
    active_list: activeList,
    pipeline_version: gs.pipelineVersion,
  };
};

export default normalizeToBusinessAPI;
